"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const detect_utils_1 = require("@/common/detect_utils");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const secretPassword = (0, react_redux_1.useSelector)((state) => state.roomData.secret_password);
    const secretHint = (0, react_redux_1.useSelector)((state) => state.roomData.secret_hint);
    const { register, formState: { errors }, } = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        defaultValues: { secret_password: secretPassword || '', secret_hint: secretHint || '' },
    });
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const secretPasswordMsg = t('비밀번호를 작성해주세요');
    const secretHintMsg = t('힌트를 작성해주세요');
    return ((0, jsx_runtime_1.jsxs)(SecretInputsWrapper, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { children: t('비밀번호') }), (0, jsx_runtime_1.jsx)("input", Object.assign({ maxLength: 64, placeholder: secretPasswordMsg }, register('secret_password', {
                        required: secretPasswordMsg,
                        validate: v => (0, detect_utils_1.validateWhiteSpace)(v) || secretPasswordMsg,
                    }), { onBlur: e => dispatch((0, roomCreateStore_1.setSecretPassword)(e.target.value)) })), errors.secret_password && (0, jsx_runtime_1.jsx)("h5", { children: errors.secret_password.message })] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { children: t('비밀번호 힌트') }), (0, jsx_runtime_1.jsx)("input", Object.assign({ maxLength: 64, placeholder: `${t('비밀번호')} ${secretHintMsg}` }, register('secret_hint', {
                        required: secretHintMsg,
                        validate: v => (0, detect_utils_1.validateWhiteSpace)(v) || secretHintMsg,
                    }), { onBlur: e => dispatch((0, roomCreateStore_1.setSecretHint)(e.target.value)) })), errors.secret_hint && (0, jsx_runtime_1.jsx)("h5", { children: errors.secret_hint.message })] })] }));
}
exports.default = default_1;
const SecretInputsWrapper = styled_1.default.div `
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  margin-bottom: 20px;
  > div {
    display: flex;
    flex-direction: column;
    color: rgba(0, 0, 0, 0.8);
    line-height: 24px;
    font-size: 16px;
    span {
      margin-bottom: 8px;
    }
    input {
      width: 100%;
      height: 48px;
      padding: 0 14px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      :focus {
        border: 1px solid black;
      }
    }
    h5 {
      margin-top: 3px;
      line-height: 18px;
      font-size: 14px;
      color: #eb5757;
    }
  }
`;
